import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const OAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showCloseMessage, setShowCloseMessage] = useState(false);

  useEffect(() => {
    console.log('OAuthCallback running');
    const access_token = searchParams.get('access_token');
    const refresh_token = searchParams.get('refresh_token');
    const code = searchParams.get('code');
    const provider = searchParams.get('provider');
    const error = searchParams.get('error');
    console.log({ access_token, refresh_token, code, provider, error });

    if (error) {
      console.log('OAuth error:', error);
      navigate('/login?error=' + encodeURIComponent(error));
      return;
    }

    // If tokens are present, store them and redirect or show close message
    if (access_token && refresh_token) {
      localStorage.setItem('token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      const returnTo = localStorage.getItem('oauth_return_to') || '/dashboard';
      localStorage.removeItem('oauth_return_to');
      localStorage.setItem('oauth_complete', Date.now().toString());
      console.log('Redirecting to', returnTo);
      if (window.opener) {
        // If in a popup, redirect and close
        window.location.href = returnTo;
      } else {
        // If in a new tab, show close message and try to close after a delay
        setShowCloseMessage(true);
        setTimeout(() => {
          window.close();
        }, 2000);
      }
      return;
    }

    // If code and provider are present, this is the popup flow
    if (code && provider) {
      console.log('Posting message to opener', { provider, code });
      window.opener?.postMessage(
        { type: 'oauth-callback', provider, code },
        window.location.origin
      );
      window.close();
    }
  }, [searchParams, navigate]);

  if (showCloseMessage) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-lg font-medium text-gray-900">You are now logged in!</h2>
          <p className="mt-2 text-sm text-gray-500">
            You can close this tab and return to your original window.
          </p>
          <button onClick={() => window.close()} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded">
            Close Tab
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h2 className="text-lg font-medium text-gray-900">Completing sign in...</h2>
        <p className="mt-2 text-sm text-gray-500">
          Please wait while we complete your sign in.
        </p>
      </div>
    </div>
  );
}; 